import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# ⏳ راهنمای تخصیص‌های تعلیقی (Pending Allocations)

پلتفرم کارخانه‌سازی میمزاد — سند راهنمای تخصیص دیرهنگام پالت‌ها

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## ۱. مفهوم تخصیص دیرهنگام (Late Allocation)
هنگامی که خروج کالا یا مصرف در خط تولید ثبت می‌شود اما شماره پالت دقیقاً مشخص نیست، سیستم یک رکورد **تخصیص تعلیقی** ثبت می‌کند تا موجودی اسمی با موجودی فیزیکی هماهنگ بماند.

## ۲. تعیین تکلیف پالت‌های معلق
در این صفحه می‌توانید لیست کلیه تراکنش‌های در انتظار تعیین پالت را مشاهده کرده و با اسکن یا انتخاب پالت واقعی، تخصیص را قطعی یا نامشخص نمایید.

export default Layout;

